import { format } from 'date-fns/format'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useRemoteClientPost } from '../../configs/http-client'
import { useLocalStorage } from '../../remote/local-storage'
import { formatToBRL } from '../utils/formatCurrency'
import { formatPhone } from '../utils/formatPhone'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from './ui/table'

export function TableDefaulter() {
  const { getUnitId } = useLocalStorage()
  const [loading, setLoading] = useState(false)
  const [params] = useSearchParams()
  const [data, setData] = useState<ResponseOverdue[] | null>(null)
  const { httpClientPost } = useRemoteClientPost('finance')

  useEffect(() => {
    if (!loading) {
      setLoading(true)
      httpClientPost('/pagamentos/inadimplentes', { idUnidade: getUnitId() })
        .then((res) => {
          console.log(res)
          setData(res.data.data)
        })
        .finally(() => {
          setLoading(false)
        })
    }
  }, [params])

  return (
    <div className="w-full py-4">
      <h3 className="text-acelerait-black text-2xl font-bold">Inadimplentes</h3>
      <div className="h-[calc(100vh-230px)] overflow-y-auto">
        <Table className="">
          <TableHeader>
            <TableRow>
              <TableHead className="w-[180px]">Nome</TableHead>
              <TableHead className="">Email</TableHead>
              <TableHead className="">Data vencimento</TableHead>
              <TableHead className="">valor</TableHead>
              <TableHead className="">telefone</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody className="">
            {data &&
              data.map((item, index) => (
                <TableRow key={index}>
                  <TableCell>{item.nome}</TableCell>
                  <TableCell>{item.email}</TableCell>
                  <TableCell>{format(new Date(item.dataVencimento), 'dd/MM/yyyy')}</TableCell>
                  <TableCell>{formatToBRL(item.totalVencido?.toString())}</TableCell>
                  <TableCell>{formatPhone(item.telefone)}</TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </div>
    </div>
  )
}

type ResponseOverdue = {
  idUsuario: number
  nome: string
  documento: string
  dataVencimento: string
  telefone: string
  email: string
  valor: number
  totalVencido: number
  pagamentos: Array<{
    id: number
    valor: number
    dataVencimento: string
  }>
}
